import { trackRudderstackEvent } from '@/hooks/useRudderstackAnalytics'

// Page-lifetime dedupe set shared across every Braze lead-capture path: the
// iframe submit listener in hooks/useBraze.ts and the postMessage handler in
// components/ClientPortal.tsx. Both can fire for a single modal submission —
// the listener catches the in-iframe form submit while the modal's own HTML
// posts back to the parent — so without this the SMS Mktg Welcome Modal funnel
// would record two `email_opt_in_submitted` events for one lead. Mirrors the
// dedupe in utils/trackGenerateLead.ts.
const trackedOptIns = new Set<string>()

// Test-only helper: clears the dedupe set so each test starts fresh.
// Production code should not call this — it would defeat the dedupe.
export const _resetTrackedOptInsForTesting = (): void => {
  trackedOptIns.clear()
}

/**
 * Fires the client-side RudderStack `email_opt_in_submitted` event — step 2 of
 * the SMS Mktg Welcome Modal funnel — at most once per email per page lifetime.
 *
 * Both Braze submit paths call this the instant the email modal is submitted,
 * before the SMS opt-in timer starts. The funnel keys on this instead of the
 * slow server-side `generate_lead`.
 */
export const trackEmailOptInSubmitted = (
  email: string,
  properties?: { email_subscribed?: boolean },
): void => {
  const trimmed = email.trim()
  if (!trimmed || trackedOptIns.has(trimmed)) return
  trackedOptIns.add(trimmed)

  trackRudderstackEvent('email_opt_in_submitted', { ...properties })
}
